export function brandStatusDescriptionCore() {
    const endpoint = '/vistaorder/brandStatusDescriptions';

    return {
        endpoint,
    };
  }

  export function brandStatusDescriptionFilter() {
    const parameter = 'BrandStatusDescription';

    // Get rows
    const getRows = (data) => {
      const rows = [];

      data.forEach((row, i) => {
        // Text/numeric values
        rows[i] = {
          value: row.filterValue,
          label: row.filterText,
        };
      });

      return rows;
    };

    return {
      parameter,
      getRows: getRows
    };
  }
